export default () => ({
    categorias: [],
    blogs: [],
    blog: {},
    select: {},
})